import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="editable-text"
export default class extends Controller {
  static targets = ["input", "actions", "editIcon"]
  static values = { url: String }

  connect() {
    this.originalValue = this.inputTarget.value
  }

  startEdit() {
    this.actionsTarget.classList.remove("hidden")
    this.editIconTarget.classList.add("hidden")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  save() {
    if (this.hasUrlValue) {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml"
        },
        body: JSON.stringify({ custom_name: this.inputTarget.value })
      }).then(response => {
        if (response.ok) {
          this.originalValue = this.inputTarget.value
        } else {
          console.error("Failed to save document name")
          this.inputTarget.value = this.originalValue
        }
      }).catch(error => {
        console.error("Error saving document name:", error)
        this.inputTarget.value = this.originalValue
      })
    } else {
      // Fallback: submit the closest form if no URL value is set
      const form = this.inputTarget.closest("form")
      if (form) {
        form.requestSubmit()
      }
    }
    this.hideActions()
  }

  cancel() {
    this.inputTarget.value = this.originalValue
    this.hideActions()
    this.inputTarget.blur()
  }

  hideActions() {
    this.actionsTarget.classList.add("hidden")
    this.editIconTarget.classList.remove("hidden")
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.cancel()
    }
  }
}
